import { adminHttpClient } from '../../../../../commons/adminHttpClient'
import { NamedItemInt } from '../../../../../../domain/common/namedItem'

export type CategoryResponse = NamedItemInt & {
  isCustom: boolean
  icon: string
}

export const getPerksMainCategories = (productClassId: string, planPeriodId: string): Promise<CategoryResponse[]> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/ClassDesign/MainCategories/${productClassId}/${planPeriodId}`)
}
